import { useEffect, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setViewportWidth } from '../../../../store/app/factory';

export function useViewModel() {
  const dispatch = useDispatch();

  const windowResizeHandler = () => dispatch(setViewportWidth(window.innerWidth));

  useLayoutEffect(() => {dispatch(setViewportWidth(window.innerWidth))}, []);

  useEffect(() => {
    window.addEventListener('resize', windowResizeHandler);

    return () => {
      window.addEventListener('resize', windowResizeHandler);
    };
  }, []);
}
